import { apolloClient } from "@/plugins/vue-apollo";
import { doMutation } from "../../core-module/util/graphqlHelper";

const updateGetTrainingCategoriesCache = ({ trainingCategory }) => {
  try {
    if (trainingCategory) {
      const cacheKey = {
        query: require("../api/query/getTrainingCategories.gql"),
        variables: { pageInput: { skip: 0, limit: 0 } },
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (cachedData?.getTrainingCategories) {
        const existingIndex =
          cachedData.getTrainingCategories.trainingCategories.findIndex(
            x => x._id === trainingCategory._id
          );

        if (existingIndex < 0) {
          cachedData.getTrainingCategories.trainingCategories.unshift(
            trainingCategory
          );
        }

        apolloClient.writeQuery({ ...cacheKey, data: cachedData });
      }
    }
  } catch (e) {
    console.log(
      "createOrUpdateTrainingCategory.updateGetTrainingCategoriesCache:exception:",
      e.message
    );
  }
};

export const createOrUpdateTrainingCategory = trainingCategory => {
  const mutation = require("../api/mutation/createOrUpdateTrainingCategory.gql");
  const variables = { input: trainingCategory };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetTrainingCategoriesCache({
        trainingCategory: data.createOrUpdateTrainingCategory,
      });

      return { data: data.createOrUpdateTrainingCategory };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
